import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addDistrict, addState, deleteDistrict, deleteState, editEmployee, registerEmployee } from "src/redux/api/_hr.api";
import { EditEmployeeFormValues } from "src/schemas/edit_employee";
import { employeeKeys } from "./useFetchEmployees";

export const useAddState = () => {
  return useMutation({
    mutationFn: ({
      employeeId,
      state,
    }: {
      employeeId: number;
      state: string;
    }) => addState(employeeId, state),
    onSuccess: () => {
      toast.success("State Added");
    },

    onError: (error) => {
      console.error(error);
      toast.error("Failed to add state");
    },
  });
};

export const useDeleteState = () => {
  return useMutation({
    mutationFn: (id: string) => deleteState(id),
    onSuccess: () => {
      toast.success("State Added");
    },

    onError: (error) => {
      console.error(error);
      toast.error("Failed to add state");
    },
  });
};

export const useAddDistrict = () => {
  return useMutation({
    mutationFn: ({
      employeeId,
      district,
    }: {
      employeeId: number;
      district: string;
    }) => addDistrict(employeeId, district),

    onSuccess: () => {
        toast.success("State Added");
    },

    onError: (error) => {
      console.error(error);
      toast.error("Failed to add state");
    },
  });
};

export const useDeleteDistrict = () => {
  return useMutation({
    mutationFn: (id: string) => deleteDistrict(id),

    onSuccess: () => {
      toast.success("State Added");
    },

    onError: (error) => {
      console.error(error);
      toast.error("Failed to add state");
    },
  });
};

export const useEditEmployee = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({values, id}: {values: Partial<EditEmployeeFormValues>, id: number}) => editEmployee(values, id),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: employeeKeys.all
      });
      
      toast.success("Employee Updated!");
    },

    onError: (error) => {
      toast.error("Failed to Update Employee!");
      console.error(error, 'edit employee failed.');
    }
  })
};

